import BasePaymentMethod from './basePaymentMethod.jsx'
import createZipMoney from '../zipMoney.jsx'

export default class ZipMoney extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    this.messageKey = 'payment'
    this.makeZipMoney(payment)
  }

  async makeZipMoney (payment){
    this.zipMoney = await createZipMoney(payment, payment.booking)
    this.hasLoaded = true
  }

  eligible () {
    return this.payment.features.zipMoney
  }

  failed () {
    const errors = [{message: 'Could not complete your Zip Money application due to technical issues, please select a different payment option or try again later.'}]
    this.payment.serverErrorsPanel.setErrors(errors, this.messageKey)
    this.zipMoney.close()
  }

  success () {
    this.payment.serverErrorsPanel.clear(this.messageKey)
    this.zipMoney.close()
  }

  referred (referenceNumber) {
    const errors = [{
      message: `Your Zip Money application (reference ${referenceNumber}) is under referral, your spot on this trip has not been secured.
        However, once Zip Money have reached an outcome you will receive confirmation by email.
        If approved, please go through the booking process again or contact one of our specialists to confirm the booking.`,
    }]
    this.payment.serverErrorsPanel.setErrors(errors, this.messageKey)
    this.zipMoney.close()
  }

  declined () {
    const errors = [{message: 'Your Zip Money application has been rejected. To proceed with booking please select an alternative payment method below.'}]
    this.payment.serverErrorsPanel.setErrors(errors, this.messageKey)
    this.hasFailed = true
    this.zipMoney.close()
  }

  renderTermsAndConditions () {
  }

  renderPaymentSummary () {
  }

  book () {
    this.payment.showLoading()
  }

  render () {
    return this.zipMoney
  }
}
